import styled from 'styled-components';
import * as StyledSystem from 'styled-system';
import { css } from '@styled-system/css';
import { extraConfig } from './config.js';
import { PseudoPropStyles } from './PseudoPropsStyles.js';

const {
  compose
} = StyledSystem;
/* ======================================= */
const getPseudoStyles = props => {
  const pseudoProps = Object.keys(props).filter(propName => propName.startsWith('_'));
  if (pseudoProps.length === 0) {
    return {};
  }
  const pseudoStyles = {};
  pseudoProps.forEach(pseudoProp => {
    if (PseudoPropStyles[pseudoProp] != null) {
      pseudoStyles[PseudoPropStyles[pseudoProp]] = props[pseudoProp];
    }
  });
  return css(pseudoStyles);
};
const systemProps = compose(StyledSystem.background, StyledSystem.border, StyledSystem.color, StyledSystem.grid, StyledSystem.layout, StyledSystem.position, StyledSystem.shadow, StyledSystem.space, StyledSystem.typography, StyledSystem.flexbox, extraConfig);
/**
 * Name of props that we don't want to forward to the DOM
 * @privateRemarks options,selectProps,theme are props from `react-select` remove theses when component changes
 */
const systemPropsNames = systemProps?.propNames;
const pseudoPropNames = Object.keys(PseudoPropStyles);
const blackListPropNames = ['spacing', 'fontSizeFormat', 'variant', 'selectProps', 'theme', 'isInvalid', 'isDisabled'];
/**
 * Name of props that we want to forward to the DOM
 */
const whiteListPropNames = ['hidden', 'fill', 'width', 'height'];
/**
 * Box is the most abstract component on top of which all other BlockParty components are built. By default, it renders a `div` element.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/box)
 * - [Props](https://blockparty.endpoint.com/components/box#props)
 * <br />
 *
 */
const Box = styled.div.withConfig({
  shouldForwardProp: prop => {
    return ![...systemPropsNames, ...pseudoPropNames, ...blackListPropNames].includes(prop) || [...whiteListPropNames].includes(prop);
  }
}).withConfig({
  displayName: "Box",
  componentId: "sc-8w9j0a-0"
})(["box-sizing:border-box;", ";", ";"], systemProps, getPseudoStyles);
Box.displayName = 'Box';

export { Box, systemProps };
